<template>
  <div class="vr360-flex-column vr360-app-main__empty-state">
    <i class="vr360-icon bg-shared-stream"></i>
    <p class="vr360-text-reg vr360-text-gray-3">You follow the link: </p>
    <p class="vr360-text-reg vr360-text-gray-3">{{ $route.params.key }}</p>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  name: "ShowSharedStream",
  data() {
    return {
      script: null,
      sourceVideo: "",
      stateVideo: "Play",
      time: 0,
      isStream: false,
      isNewStream: false,
      linkFinded: false
    };
  },
  created() {
    if (this.stream.id) {
      this.$router.replace({ name: "ListPublicStreams" });
    }
    this.getStream(this.$route.params.key);
  },
  methods: {
    ...mapActions({
      getStream: "stream/fetchSharedStream",
      clearStreams: "stream/clearStreams"
    })
  },
  watch: {
    stream(val) {
      if (val) {
        this.$router.push({
          name: "ShowStream",
          params: {
            id: this.stream.id
          }
        });
      }
    }
  },
  computed: {
    ...mapGetters({
      stream: "stream/currentStream"
    })
  }
};
</script>

<style lang="scss">
a-scene {
  z-index: 3;
}
.vr360-app-main__online-stream__header,
.vr360-app-main__online-stream__bottom {
  z-index: 4;
}
.back {
  position: fixed;
  top: 20px;
  left: 40px;
  z-index: 9999;
  color: #fff;
}
a-scene.fullscreen {
  position: fixed;
  top: 0;
  left: 0;
}
a-scene.fullscreen .back {
  width: 100% !important;
  height: 100% !important;
  top: 0 !important;
  left: 0 !important;
  right: 0 !important;
  bottom: 0 !important;
  position: fixed !important;
}
</style>
